/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  resultContent: 'resultContent_b95d8395',
  resultItem: 'resultItem_b95d8395',
  peoplePickerPersona: 'peoplePickerPersona_b95d8395',
  peoplePicker: 'peoplePicker_b95d8395',
  peoplePickerPersonaContent: 'peoplePickerPersonaContent_b95d8395',
};

export = styles;

loadStyles([{"rawString":".resultContent_b95d8395{display:table-row}.resultContent_b95d8395 .resultItem_b95d8395{display:table-cell;vertical-align:bottom}.peoplePickerPersona_b95d8395{width:180px}.peoplePickerPersona_b95d8395 .ms-Persona-details{width:100%}.peoplePicker_b95d8395 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_b95d8395{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}"}]);
/* tslint:enable */